import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Sparkles, Check } from "lucide-react";
import { Link } from "react-router-dom";

export default function Pricing() {
  const [p, setP] = useState({});
  useEffect(()=>{ api.get("/config/pricing").then(r=>setP(r.data)); }, []);
  const labels = {
    banquet_hall: "Banquet Hall", lawn: "Lawn", catering: "Catering",
    hotel_banquet: "Hotel Banquet", decoration: "Decoration", combo_all: "All-in-One Combo"
  };
  return (
    <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
      <div className="text-[10px] uppercase tracking-widest-2 text-[color:var(--wine)]">Owner Subscriptions</div>
      <h1 className="font-display text-5xl mb-3">Simple pricing, big reach.</h1>
      <p className="text-neutral-600 max-w-2xl">List your venue on India's most curated wedding marketplace. Six-month subscriptions renew automatically with a friendly reminder 45 days before expiry.</p>
      <div className="mt-10 grid md:grid-cols-3 gap-6">
        {Object.entries(p.categories || {}).map(([k, v])=>(
          <div key={k} className={`card-luxury p-6 ${k==="combo_all" ? "border-2 border-[color:var(--gold)] relative" : ""}`}>
            {k==="combo_all" && <span className="absolute -top-3 right-6 px-3 py-1 rounded-full bg-[color:var(--gold)] text-black text-[10px] uppercase tracking-widest-2 inline-flex items-center gap-1"><Sparkles className="w-3 h-3"/> Best value</span>}
            <div className="font-display text-2xl">{labels[k] || k}</div>
            <div className="flex items-baseline gap-2 mt-3">
              <span className="text-3xl font-display text-[color:var(--wine)]">₹{Number(v["6m"]).toLocaleString("en-IN")}</span>
              <span className="text-xs text-neutral-500">/ 6 months</span>
            </div>
            <div className="text-xs text-neutral-500 mt-1">or ₹{Number(v["12m"]).toLocaleString("en-IN")} / 12 months (saves 10%)</div>
            <ul className="mt-5 space-y-2 text-sm text-neutral-700">
              <li className="flex items-center gap-2"><Check className="w-4 h-4 text-[color:var(--emerald)]"/> Unlimited listing photos</li>
              <li className="flex items-center gap-2"><Check className="w-4 h-4 text-[color:var(--emerald)]"/> Owner dashboard & inquiries</li>
              <li className="flex items-center gap-2"><Check className="w-4 h-4 text-[color:var(--emerald)]"/> 2-year availability calendar</li>
              <li className="flex items-center gap-2"><Check className="w-4 h-4 text-[color:var(--emerald)]"/> Packages & catering menus</li>
              {k==="combo_all" && <li className="flex items-center gap-2"><Check className="w-4 h-4 text-[color:var(--emerald)]"/> All categories in one plan</li>}
            </ul>
            <Link to="/register" className="btn-wine mt-6 w-full justify-center">Get started</Link>
          </div>
        ))}
      </div>
      <div className="mt-14 card-luxury p-8 grid md:grid-cols-2 gap-8 items-center">
        <div>
          <div className="text-[10px] uppercase tracking-widest-2 text-[color:var(--wine)]">Premium Spotlight</div>
          <h2 className="font-display text-3xl mt-1">Get featured in the top-10 auto-slider per city</h2>
          <p className="text-neutral-600 mt-2 text-sm">Only 10 premium slots per city. Book upto 5 years in advance.</p>
        </div>
        <div className="text-right">
          <div className="text-3xl font-display text-[color:var(--wine)]">₹{Number(p.premium_slot?.["6m"] || 0).toLocaleString("en-IN")}</div>
          <div className="text-xs text-neutral-500">per 6 months per city</div>
        </div>
      </div>
    </div>
  );
}
